export enum LeadCreditHoldStatusEnum {
    PENDING = 'Pending',
    PRODUCT_NOT_ELIGIBLE = 'Product not Eligible',
    HIGH_DBR = 'High DBR',
    INCOMPLETE_DOCUMENTS = 'Incomplete Documents',
    NEGATIVE_AREA = 'Negative Area',
    NEGATIVE_PAYMENT = 'Negative Repayment',
}
